import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SIZE = 96;
const HOLD_MS = 700;
const FLY_MS = 620;

/* Splash: logo appears centered, then flies into its slot in the navbar. */
export default function LogoIntro() {
    const { pathname } = useLocation();
    const [state, setState] = useState(() => {
        if (typeof window === "undefined") return null;
        if (pathname.startsWith("/admin")) return null;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
        return { phase: "center", transform: "translate(-50%, -50%) scale(1)" };
    });
    const isPartner = pathname.startsWith("/partner");

    useEffect(() => {
        if (!state) return undefined;
        const timers = [];
        timers.push(setTimeout(() => {
            const target = document.querySelector('[data-testid="itly-logo-img"]');
            if (!target) { setState(null); return; }
            const r = target.getBoundingClientRect();
            const dx = r.left + r.width / 2 - window.innerWidth / 2;
            const dy = r.top + r.height / 2 - window.innerHeight / 2;
            const s = r.width / SIZE;
            setState({ phase: "fly", transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(${s})` });
            timers.push(setTimeout(() => setState(null), FLY_MS + 80));
        }, HOLD_MS));
        return () => timers.forEach(clearTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!state) return null;
    const flying = state.phase === "fly";
    return (
        <div
            data-testid="logo-intro"
            className={`itly-logo-intro${flying ? " is-flying" : ""}`}
            aria-hidden="true"
        >
            <img
                src={isPartner ? "/assets/itly/logo-partner.png" : "/assets/itly/logo-turista.png"}
                alt=""
                className="itly-logo-intro-img"
                style={{
                    width: SIZE,
                    height: SIZE,
                    background: isPartner ? "#B4C3CA" : "#8BAFC7",
                    transform: state.transform,
                    transitionDuration: `${FLY_MS}ms`,
                }}
            />
            <span className="itly-logo-intro-word itly-wordmark">
                ITLY{isPartner && <span style={{ color: "var(--itly-muted)", fontWeight: 500 }}> HUB</span>}
            </span>
        </div>
    );
}
